
import React from "react";
import { SectionHeader } from "@/components/ui/section-header";
import TestimonialCarousel from "./TestimonialCarousel";
import { generateReviewSchema } from "@/lib/schema";

// Testimonials with ratings and updated images
const testimonials = [
  {
    id: 1,
    quote: "Grandpal was a lifesaver during a very difficult time. Their guidance through the Fair Deal process and help finding the right nursing home for my father made all the difference.",
    author: "Mary O'Brien",
    role: "Dublin",
    imageUrl: "/lovable-uploads/0ad6c159-fe06-47d7-8f6d-d99cb4ba5454.png",
    rating: 5,
    datePublished: "2023-09-12"
  }, {
    id: 2,
    quote: "Navigating nursing home options for my mother would have been overwhelming without Grandpal's assistance. Their team was compassionate, knowledgeable, and responsive throughout.",
    author: "John Murphy",
    role: "Cork",
    imageUrl: "/lovable-uploads/b4d34310-9102-49bb-9646-dd326198f81f.png",
    rating: 5,
    datePublished: "2023-10-05"
  }, {
    id: 3,
    quote: "The resources Grandpal provided helped me understand the Fair Deal scheme in a way that official documents never did. Their step-by-step guidance saved us time and reduced our stress.",
    author: "Sarah Walsh",
    role: "Galway",
    imageUrl: "/lovable-uploads/8025147e-7a86-48db-993a-8d908f35f504.png",
    rating: 4,
    datePublished: "2023-11-28"
  }, {
    id: 4,
    quote: "I can't thank Grandpal enough for their support during our family's care journey. Their expert advice and genuine care made a difficult process much easier.",
    author: "Michael Kelly",
    role: "Kildare",
    imageUrl: "/lovable-uploads/a3e54f8d-a2cd-46d2-a078-9e9e3df425b7.png",
    rating: 5,
    datePublished: "2024-01-15"
  }
];

export default function TestimonialsSection() {
  // Generate structured data for SEO
  const reviewSchema = generateReviewSchema(testimonials.map(t => ({
    author: t.author,
    reviewBody: t.quote,
    datePublished: t.datePublished,
    rating: t.rating
  })), {
    name: "Grandpal",
    type: "Organization"
  });
  
  return <section className="py-20 relative overflow-hidden">
      {/* Replace background image with a gradient background */}
      <div className="absolute inset-0 w-full h-full z-0 bg-gradient-to-br from-grandpal-green-dark to-grandpal-green-darkHover" />
      
      <div className="container relative z-10">
        <SectionHeader title="What Our Clients Say" subtitle="Hear from families who have found the right care solution with our help." centered className="mb-16 text-white" />
        <TestimonialCarousel testimonials={testimonials} />
      </div>
      
      {/* Add review schema */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(reviewSchema)
    }} />
    </section>;
}
